import styled from 'styled-components'

export const CarrierServiceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
`
